// extracted by css-extract-rspack-plugin
export default {"drawer":"wKzeurEioOEbpuc___drawer___"};